import React from "react";
import Banner from "../../component/Banner/Banner";
import NewsMarque from "../../component/News Marquee/NewsMarque";
import AboutRDA from "../../component/About RDA/AboutRDA";
import Notices from "../../component/Notices/Notices";
import Vision from "../../component/Vision/Vision";
import Projects from "../../component/Projects/Projects";
import PrivateSocieties from "../../component/Private Societies/PrivateSocieties";
import AboutDirector from "../../component/About Director/AboutDirector";
import Complaint from "../../component/Complaint/Complaint";
import NewsSlider from "../../component/News Slider/NewsSlider";
import "../../App.css";
import PartnerMarquee from "../../component/Partner Marquee/PartnerMarquee";
import SideCTA from "../../component/Navbar/SideCTA";

const Home = () => {
  return (
    <>
      <div>
        <Banner />
        <NewsMarque />
        <AboutRDA />
        <Notices />
        <Vision />
        <Projects />
        <PrivateSocieties />
        <AboutDirector />
        <Complaint />
        <PartnerMarquee />
        <NewsSlider />
            <div className="fixed z-20 md:bottom-6 md:right-6 bottom-4 right-4">
        <SideCTA />
        </div>
      </div>
    </>
  );
};

export default Home;
